import { render, staticRenderFns } from "./AgeVerificationStatusView.vue?vue&type=template&id=45c3df61&scoped=true&"
import script from "./AgeVerificationStatusView.vue?vue&type=script&lang=ts&"
export * from "./AgeVerificationStatusView.vue?vue&type=script&lang=ts&"
import style0 from "./AgeVerificationStatusView.vue?vue&type=style&index=0&id=45c3df61&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c3df61",
  null
  
)

export default component.exports